import { Button } from "@mantine/core";
import { useState } from "react";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { usePostApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import {
  clearUsersToSendWelcomeEmail,
  setIsSendingWelcomeEmail,
  setSelectAll,
} from "src/redux/slices/managementSlice";
import { Notification } from "src/utils/Notification";

const WelcomeEmailsControls = () => {
  const dispatch = useDispatch();

  const { isSendingWelcomeEmails, usersToSendWelcomeEmail } = useSelector(
    state => state.managementSlice,
  );
  const [isLoading, setIsLoading] = useState(false);
  const toggleSendingWelcomeEmails = () => {
    dispatch(clearUsersToSendWelcomeEmail());
    dispatch(setIsSendingWelcomeEmail(!isSendingWelcomeEmails));
  };
  const handleCancel = () => {
    dispatch(setSelectAll(false));
    toggleSendingWelcomeEmails();
  };
  const { post } = usePostApi();

  const handleSendEmails = async () => {
    try {
      setIsLoading(true);
      const emailPromises = usersToSendWelcomeEmail.map(userid =>
        post({
          request: "send-welcome",
          body: { params: { userid } },
        }),
      );
      await Promise.all(emailPromises);

      Notification(
        "Success",
        "The welcome mail has been sent to this user successfully",
        "green",
      );
    } catch {
      Notification("Error", "Failed to send welcome emails", "red");
    } finally {
      setIsLoading(false);
    }

    toggleSendingWelcomeEmails();
  };

  return (
    <div style={{ display: "flex", gap: 5 }}>
      {isSendingWelcomeEmails && (
        <Button variant="outline" color="red" onClick={handleCancel}>
          Cancel
        </Button>
      )}
      {isSendingWelcomeEmails ? (
        <ConfirmationButton
          onConfirm={handleSendEmails}
          buttonProps={{ disabled: usersToSendWelcomeEmail.length === 0 }}
          loading={isLoading}
          modalText="Confirm sending emails to multiple users">
          Confirm sending
        </ConfirmationButton>
      ) : (
        <Button variant="outline" onClick={toggleSendingWelcomeEmails}>
          Send Welcome Emails
        </Button>
      )}
    </div>
  );
};
export default WelcomeEmailsControls;
